import { render, staticRenderFns } from "./DocumentGenerator.vue?vue&type=template&id=6f17e3f8&scoped=true&"
import script from "./DocumentGenerator.vue?vue&type=script&lang=js&"
export * from "./DocumentGenerator.vue?vue&type=script&lang=js&"
import style0 from "./DocumentGenerator.vue?vue&type=style&index=0&id=6f17e3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f17e3f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VContainer})
